var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"full-height",attrs:{"fluid":""}},[(_vm.$store.state.openClaim)?_c('log-list',{attrs:{"claimid":_vm.$store.state.openClaim.id}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }